import React from "react";
import { ProductInstance } from "../../../domain/ProductInstance";
import { Checkbox, Icon, Poptip } from "@optimizely/axiom";
import { useOpalBranding } from "../../../hooks/useOpalBranding/useOpalBranding";

type GenAIInstanceCheckboxProps = {
    instance: ProductInstance;
    disabled: boolean;
    enableInstanceGenAIFlag: boolean;
    handleToggle: ({ id, enabled }: { id: string; enabled: boolean }) => void;
};

export const GenAIInstanceCheckbox = ({
    instance,
    disabled,
    enableInstanceGenAIFlag,
    handleToggle
}: GenAIInstanceCheckboxProps) => {
    const { opalName } = useOpalBranding();

    return (
        <Checkbox
            onChange={() => {
                handleToggle({
                    id: instance.instanceId,
                    enabled: instance.genAIEnabled || false
                });
            }}
            isDisabled={disabled || (enableInstanceGenAIFlag && !instance.optiIdEnabled)}
            checked={!!instance.genAIEnabled}
            data-cy={`ors-instance-${instance.instanceId}-toggle`}
            className="push-quad--left"
            key={instance.instanceId}
            label={
                <span>
                    {instance.nickname || instance.instanceName}
                    {enableInstanceGenAIFlag && !instance.optiIdEnabled && (
                        <Poptip
                            content={`Opti ID must be enabled for this instance in order to enable ${opalName}`}
                            isInline
                            style={{ paddingLeft: "3px" }}
                            position="right"
                        >
                            <Icon name="circle-info" size="small" data-testid="opti-id-disabled-instance-info-icon" />
                        </Poptip>
                    )}
                </span>
            }
        />
    );
};

GenAIInstanceCheckbox.displayName = "GenAIInstanceCheckbox";
